module.exports = __webpack_public_path__ + "static/media/vip-access-store-tile-2-promo.e5b950d9.png";